import { useSession } from '../../Components/Session';
import { useSyncedPreference } from '../../Data/Preference';
import newMenu from '../newMenu';

const MAX_PINNED = 2;

const usePinnedMenuItems = () => {
    const { hasFeature, isRoleSufficient, isAdmin } = useSession();
    const [pins, setPins] = useSyncedPreference('nav:pinned', []);

    const pinnable = newMenu
        .filter((section) => !section.admin || isAdmin(section.admin))
        .filter((section) => !section.role || isRoleSufficient(section.role))
        .flatMap((section) => section.items)
        .filter((item) => item.pinnable !== false && !item.disabled)
        .filter((item) => !item.feature || hasFeature(item.feature))
        .filter((item) => !item.role || isRoleSufficient(item.role));

    const pinnedItems = (pins ?? [])
        .map((to) => pinnable.find((item) => item.to === to))
        .filter(Boolean);

    const pinned = pinnedItems.map((item) => item.to);
    const isFull = pinned.length >= MAX_PINNED;

    const togglePin = (to) => {
        if (pinned.includes(to)) {
            setPins(pinned.filter((pin) => pin !== to));
            return;
        }

        if (!isFull) {
            setPins([...pinned, to]);
        }
    };

    return {
        pinnedItems,
        pinned,
        isFull,
        togglePin,
    };
};

export default usePinnedMenuItems;
